import dayjs from 'dayjs';
import { Anrede, Selbstbeteiligung, Zahlungsart, Zahlweise } from '@ps20/bff-models';
import { DATEFORMAT_LOCAL_STATE } from '@ps20-frontend/utils';
import { IAppState } from './appState';

export const INITIAL_STATE: IAppState = {
  version: 7,
  antragsnummer: null,
  angebotsId: null,
  versicherungsnehmer: {
    kundenverwaltungID: '',
    isAssekuranztarif: false,
    geburtsdatum: '',
    adresse: null,
    juristisch: false,
  },
  vermittler: {
    selectedVermittlernummer: {
      eigen: {
        vertreternummer: '',
        geschaeftsstelle: '',
        zweigniederlassung: '',
      },
      fremd: {
        vertreternummer: '',
        geschaeftsstelle: '',
        zweigniederlassung: '',
      },
    },
    bnrb: '',
    isFremdvermittler: false,
  },
  vp: {
    isVn: false,
    anrede: Anrede.KEINE,
    vorname: '',
    nachname: '',
    geburtsdatum: '',
    berufsrisikogruppe: null,
    kundenverwaltungID: '',
    kundennummer: '',
    adelsbez: {
      wert: '',
      text: '',
    },
    akadgrad: {
      wert: '',
      text: '',
    },
    adresse: {
      plz: '',
      ort: '',
      strasse: '',
      hausnummer: '',
      land: {
        wert: '',
        text: '',
      },
    },
    juristisch: false,
  },
  jahresbeitrag: 0,
  gesamtbeitrag: 0,
  gesamtbeitragMitRabatt: 0,
  savedGesamtbeitragMitRabatt: 0,
  savedJahresbeitragMitRabatt: 0,
  vertragsoptionen: {
    zahlungsweise: Zahlweise.MONATLICH,
    vertragslaufzeit: 3,
    ausgewaehltevertragslaufzeit: 3,
    versicherungssumme: null,
    zahlungsart: Zahlungsart.LASTSCHRIFT,
    beginnDatum: dayjs().add(1, 'd').format(DATEFORMAT_LOCAL_STATE),
    aenderungdatum: dayjs().add(1, 'd').format(DATEFORMAT_LOCAL_STATE),
    vorversicherungVorhanden: null,
    selbstbeteiligung: Selbstbeteiligung.SELBSTBETEILIGUNG_0000,
  },
  transientState: {
    amisSessionId: '',
    sdw: null,
    zurueckZumShopModalOpen: false,
    tarifierungIsInProgress: false,
    role: null,
    featureToggles: {},
    regexps: {},
    priceGuarantee: false,
    kooperationen: null,
  },
  produkt: null,
  taasInfo: {
    hashedTaasRequest: '',
    hashedRiskData: '',
    rbdNachlass: 0,
    tbNachlass: 0,
    aktionsnachlass: 0,
    savedRbdNachlass: 0,
    savedTbNachlass: 0,
    savedAktionsnachlass: 0,
  },
  rabattstufe: 0,
};
